export function parseCost(val, removeZeroPence = false) {
  const parsed = parseFloat(val);
  if (isNaN(parsed)) {
    return removeZeroPence ? 0 : '0.00';
  }
  if (removeZeroPence && parsed === Math.floor(parsed)) {
    // Pence is zero (e.g. £4.00)
    return Math.floor(parsed);
  }
  return parsed.toFixed(2);
}

export function costString(val, removeZeroPence = false) {
  if (!val && val !== 0.0) {
    // Format null/undefined as dashes
    return '--';
  }
  return `£${parseCost(val, removeZeroPence)}`;
}

export function costStringWithCommas(
  val,
  currency = '£',
  removeZeroPence = false
) {
  if (!val && val !== 0.0) {
    // Format null/undefined as dashes
    return '--';
  }
  return `${currency}${parseFloat(
    parseCost(val, removeZeroPence)
  ).toLocaleString('en-gb', { minimumFractionDigits: 2 })}`;
}

export function getSummaryCosts(
  isLakeExclusive,
  isExoticFishery,
  estimatedPricingDetails
) {
  const estimatedBreakdown =
    estimatedPricingDetails?.pricing_details?.pricing_breakdown;

  const total_amount_no_promotion =
    parseFloat(estimatedBreakdown?.total_price_without_discount ?? '0') ||
    estimatedPricingDetails?.amount;

  const promotionApplied =
    parseFloat(parseCost(estimatedBreakdown?.promotion_discount)) > 0;
  const promotionDiscountedAmount = estimatedBreakdown?.total_price ?? 0.0;

  if (isExoticFishery) {
    const halfCostNoPromotion = parseFloat(
      parseCost(total_amount_no_promotion)
    );
    const halfCostActual = parseFloat(
      parseCost(
        promotionApplied ? promotionDiscountedAmount : total_amount_no_promotion
      )
    );
    return {
      total: halfCostNoPromotion * 2,
      advance: halfCostActual,
      balance: halfCostActual,
      isDiscounted: promotionApplied,
      discountedTotal: halfCostActual * 2,
      payable: halfCostActual,
    };
  }
  const total = parseFloat(parseCost(total_amount_no_promotion));
  const discountedTotal = parseFloat(parseCost(promotionDiscountedAmount));
  const advance = parseFloat(parseCost(estimatedBreakdown?.advance_price));
  let costToPay = promotionApplied ? discountedTotal : total;
  costToPay = Boolean(advance) && advance < costToPay ? advance : costToPay;
  return {
    total: total,
    advance: advance,
    balance: parseFloat(parseCost(estimatedBreakdown?.balance_price)),
    isDiscounted: promotionApplied,
    discountedTotal: discountedTotal,
    payable: costToPay,
  };
}
